<template>
  <a :href="href" rel="noopener noreferrer nofollow">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'VisitLink',
  inject: {
    $locale: {
      default: () => () => ({}),
    },
    $offer: {
      default: () => () => ({}),
    },
    $visitLinkParams: {
      default: () => () => [],
    },
    $component: {},
    $table: {
      default: () => () => ({}),
    },
    $block: {},
    $useOfferId: {},
  },
  computed: {
    offer() {
      return this.$offer() || {}
    },
    visitLinkParams() {
      return this.$visitLinkParams() || []
    },
    context() {
      const locale = this.$locale()
      const table = this.$table() || {}
      const { country, language, state } = locale
      const { position, totalPositions } = table
      const block = this.$block
      const useOfferId = this.$useOfferId

      const params = new URLSearchParams(document.location.search)
      const adgroupName = params.get('adgroupname')

      return Object.entries({
        offerType: this.offer.type,
        component: this.$component,
        country,
        language,
        state,
        position,
        totalPositions,
        block,
        getById: useOfferId,
        adgroupName,
        'paid-referrer': btoa(window.location.href),
        ...this.visitLinkParams,
      }).reduce((acc, [key, value]) => {
        if (value != undefined) acc[key] = value
        return acc
      }, {})
    },
    href() {
      const params = new URLSearchParams(this.context)
      const visitLinkIndetifier = this.$useOfferId ? this.offer.id : this.offer.slug
      return ['/visit/', visitLinkIndetifier, '?', params.toString()].filter(Boolean).join('')
    },
  },
}
</script>
